import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { getBackHomeUrl } from '../common/homeUrlByHost.js';

class NotFoundPage extends Component {
    render() {
        const { t } = this.props;
        const homeUrl = getBackHomeUrl();
        return (
            <div id="content">
                <Helmet>
					<title>404</title>
                    <meta name="robots" content="noindex,nofollow" />
				</Helmet>
                <div className="page-error">
                    <div className="container text-center">
                    <img src={require('../assets/images/404.png').default} alt="Hát karaoke vui nhộn" />
                        <h2 className="heading">{t("not_found_page.title", "Error 404")}</h2>
                        <p>{t("not_found_page.description", "Không tìm thấy trang hiện tại")}</p>
                        <a href={homeUrl} className="btn-yellow">
                            <i className="fa fa-angle-left" /> {t("not_found_page.back_home", "Quay về trang chủ")}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(NotFoundPage)